/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { TimestampType } from '../../models/timestamp-type';

export interface GetAdministrationLoadCarriersReportsCsv$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;
  from: TimestampType;
  to: TimestampType;
}

export function getAdministrationLoadCarriersReportsCsv(http: HttpClient, rootUrl: string, params: GetAdministrationLoadCarriersReportsCsv$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, getAdministrationLoadCarriersReportsCsv.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/csv', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

getAdministrationLoadCarriersReportsCsv.PATH = '/administration/organization-sites/{organizationSiteKey}/load-carriers/reports/csv';
